import HeroSection from "../../components/HeroSection/index.js";
import Privacy from "../../components/Privacy/index.js";
import Download from "../../components/Download/index.js";
import WhyHabitTime from "../../components/WhyHabitTime/index.js";

const Home = () => {
  return (
    <>
      <HeroSection />
      <WhyHabitTime />
      <Privacy />
      <Download />
    </>
  );
};

export default Home;
